<div *ngFor="let data of items; let i = index" class="surface-card mb-3">
  <div class="surface-card-header surface-card-header-split">
    {{ 'uiModules.requiredDataItem' | translate }} #{{ i + 1 }}
    <sh-button
      variant="text"
      severity="danger"
      size="sm"
      icon="fa-regular fa-trash"
      ariaLabel="shared.terms.remove"
      (click)="remove(i)"
    ></sh-button>
  </div>
  <div class="surface-card-body form-grid">
    <sh-field label="uiModules.mappingKey">
      <sh-input [(value)]="data.mappingKey"></sh-input>
    </sh-field>
    <sh-field label="shared.terms.field">
      <sh-input [(value)]="data.field"></sh-input>
    </sh-field>
    <sh-field label="uiModules.output">
      <sh-input [(value)]="data.output"></sh-input>
    </sh-field>
    <sh-field label="uiModules.multiple">
      <sh-toggle
        ariaLabel="uiModules.multiple"
        [(value)]="data.multiple"
      ></sh-toggle>
    </sh-field>
    <sh-field class="field-wide" label="uiModules.requestedFields">
      <su-csv-input [(values)]="data.requestedFields"></su-csv-input>
    </sh-field>
  </div>
</div>

<sh-button
  label="uiModules.addRequiredData"
  severity="secondary"
  icon="fa-regular fa-plus"
  (click)="add()"
></sh-button>
